module.exports = __webpack_public_path__ + "img/akindo.dc5d5f3f.png";